'use client'
import { create } from 'zustand'
import { combine, devtools, persist } from 'zustand/middleware'

import { NotificationTypes } from '@/lib/generated-enums'

export type Notification = {
  [NotificationTypes.CONSULTATION]: boolean
  [NotificationTypes.HOLIDAY_REQUEST]: boolean
  [NotificationTypes.ORDER]: boolean
  [NotificationTypes.REPEAT_PRESCRIPTION_REQUEST]: boolean
  [NotificationTypes.RESCHEDULE_REQUEST]: boolean
}

export const useNotificationStore = create(
  devtools(
    persist(
      combine(
        {
          data: {
            [NotificationTypes.CONSULTATION]: false,
            [NotificationTypes.HOLIDAY_REQUEST]: false,
            [NotificationTypes.ORDER]: false,
            [NotificationTypes.REPEAT_PRESCRIPTION_REQUEST]: false,
            [NotificationTypes.RESCHEDULE_REQUEST]: false,
          } as Notification,
        },
        (set) => ({
          add: (type: NotificationTypes, is_read: boolean) =>
            set((state) => ({
              ...state,
              data: { ...state.data, [type]: !is_read },
            })),
          reset: () =>
            set((state) => ({
              ...state,
              data: {
                [NotificationTypes.CONSULTATION]: false,
                [NotificationTypes.HOLIDAY_REQUEST]: false,
                [NotificationTypes.ORDER]: false,
                [NotificationTypes.REPEAT_PRESCRIPTION_REQUEST]: false,
                [NotificationTypes.RESCHEDULE_REQUEST]: false,
              } as Notification,
            })),
        })
      ),
      { name: 'notifs' }
    )
  )
)
